/**
 * Minimal className combiner for the Dispatch Deck component set.
 * Deliberately dependency-free (no clsx): variants in this codebase are
 * plain string unions resolved via `Record` lookups, so all we ever
 * need is filtering falsy segments.
 */
export function cx(...parts: ReadonlyArray<string | false | null | undefined>): string {
  const out: string[] = [];
  for (const part of parts) {
    if (typeof part === 'string' && part.length > 0) {
      out.push(part);
    }
  }
  return out.join(' ');
}
